<template>
  <div class="tool-item">
    <el-tooltip class="item" effect="light" content="直購" placement="top"></el-tooltip>
    <div>
      <a href="javascript:void(0);" v-on:click="openProdbuy">
        <img src="../../assets/contract.png" width="24" height="24">
      </a>      
    </div>
   
  </div>
</template>


<script>
import Global from "@/components/Global";
export default {
  name: "Prodbuy",
  props: ["roomInfo","staffInfo"],
  data() {
    return {
    
    };
  },
  methods: {
    openProdbuy: function() {
      if(this.staffInfo.StaffID == null) {
        alert('尚未載入完成，請稍後再試');
        return;
      }

      window.location.href = this.$conf.MessageAPI + '/Contract/openProdbuy?socialLeadId=' + this.roomInfo.SocialLeadId + '&staffId=' + this.staffInfo.StaffID;
      //window.open(this.$conf.MessageAPI + '/Contract/openProdbuy?socialLeadId=' + this.roomInfo.SocialLeadId + '&staffId=' + this.staffInfo.StaffID);
    }    
  }
};
</script> 

<style>
</style>


// WEBPACK FOOTER //
// src/components/SalesTool/Prodbuy.vue